module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/stream-http/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 292
// module chunks = 0